import { call, put } from 'redux-saga/effects';
import api from '../../../../../../services/api';
import { ClientContract } from '../../../../../../common/types/ClientContract';
import commonActions from '../../../../../../redux/common/actions';

export async function fetchSortedClientContracts(): Promise<ClientContract[]> {
  const { data: { Data } } = await api.get('/v1/client-contracts/list');
  return (Data || []).sort((a: ClientContract, b: ClientContract) => a.Name.localeCompare(b.Name));
}

export function* refreshClientContracts() {
  try {
    const sorted: ClientContract[] = yield call(fetchSortedClientContracts);
    yield put(commonActions.setClientContracts(sorted));
  } catch (e) {
    console.error('Failed to refresh client contracts:', e);
  }
}
